
<!-- KpiCards.vue -->
<script setup>
import { computed } from "vue";
import { getFundingAmount } from "@/utils/fundingUtils"

const props = defineProps({
  vouchers: {
    type: Array,
    required: true,
  },
  program: {
    type: String,
    default: "core",
  },
  includeInfrastructureFunding: {
    type: Boolean,
    default: false,
  },
})


const voucherLabel = computed(() => props.program !== "sore" ? "Vouchers Requested" : "Voucher Request Applications Redeemed")
const unitLabel = computed(() => props.program !== "sore" ? "Equipment Units Requested" : "Equipment Units Redeemed")
const fundingLabel = computed(() => props.program !== "sore" ? "Funding Requested" : "Funding Redeemed")


const unitCount = computed(() => props.vouchers.length)  

const totalVoucherCount = computed(() => {
  if (props.program === "sore") {
    // For SORE, count unique voucher requests
    const uniqueVoucherRequests = new Set(
      props.vouchers.map((v) => v.voucherRequestId ?? v.voucherId ?? "No data")
    )
    return uniqueVoucherRequests.size;
  }
  // For CORE, count total vouchers
  return props.vouchers.length;
})

const totalFundingAmount = computed(() => {
  return props.vouchers.reduce((sum, voucher) => {
    return sum + getFundingAmount(voucher, props.includeInfrastructureFunding);
  }, 0)
})

const formattedFunding = computed(() => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: 2,
  }).format(totalFundingAmount.value)
})
</script>

<template>
  <div class="kpi-grid">
    <div class="kpi-card">
      <div class="kpi-value">{{ totalVoucherCount.toLocaleString() }}</div>
      <div class="kpi-label">{{ voucherLabel }}</div>
    </div>
        <div class="kpi-card" v-show="program == 'sore'">
      <div class="kpi-value">{{ unitCount.toLocaleString() }}</div>
      <div class="kpi-label">{{ unitLabel }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-value">{{ formattedFunding }}</div>
      <div class="kpi-label">{{ fundingLabel }}</div>
    </div>
  </div>
</template>

<style scoped>
.kpi-grid {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.25rem;
}
.kpi-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: var(--color-primary-dark);
  border-radius: 8px;
  padding: 1.25rem;
  flex: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.kpi-label {
  line-height: 1.15;
  font-size: 1rem;
  color: #fff;
  font-weight: 500;
}
.kpi-value {
  margin-bottom: 0.2rem;
  line-height: 1.1;
  font-size: 1.6rem;
  font-weight: 700;
  color: #fff;
} 
</style>